import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { Direction } from "../../../shared/constants/enums";
import { LanguageService } from "../../../shared/services/language-service";
import { Adaa4DashboardsSummary } from "../models/adaa4-home-model";
import { Adaa4HomeApiService } from "../services/adaa4-home-api-service";
import { Adaa4RedirectService } from "../services/adaa4-redirect-service";
import { Adaa4GaugeComponent } from "./adaa4-gauge/adaa4-gauge";
import { buildAdaa4HomeCards } from "./adaa4-home-cards";

@Component({
  selector: "adaa-adaa4-home",
  imports: [TranslatePipe, Adaa4GaugeComponent],
  templateUrl: "./adaa4-home.html",
  styleUrl: "./adaa4-home.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Adaa4HomeComponent {
  private readonly _homeApiService = inject(Adaa4HomeApiService);
  private readonly _redirectService = inject(Adaa4RedirectService);
  private readonly _languageService = inject(LanguageService);

  summary = signal<Adaa4DashboardsSummary>({});

  cards = computed(() => {
    const language = this._languageService.current();

    return buildAdaa4HomeCards(this.summary()).map((card) => ({
      ...card,
      url: this._redirectService.dashboardUrl(card.dashboard, language),
    }));
  });

  constructor() {
    this._homeApiService.getSummary().subscribe((summary) => this.summary.set(summary));
  }

  public trend(value: number): string {
    const arrow = value < 0 ? "↓" : "↑";
    const amount = +Math.abs(value).toFixed(2);
    return this._languageService.direction() === Direction.RTL ? `${arrow}%${amount}` : `${arrow}${amount}%`;
  }

  public open(event: MouseEvent, url: string): void {
    event.preventDefault();
    this._redirectService.openInNewTab(url);
  }
}
